// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__izACZ","loading":"Skeleton_loading__kLn+E"};